import { Autocomplete, Box, Chip, FormControl, FormHelperText, TextField, Typography } from '@mui/material'
import styles from './styles.module.scss'
import { RenderTooltip } from '../../../../../components/utilities/RenderTooltip'

const TagsInput = ({
  value,
  onChange,
  error,
  label,
  placeholder = '',
  tooltip = '',
  options = [],
  required = false,
  disabled = false,
}) => {
  return (
    <Box className={styles.container}>
      <Box className={styles.label}>
        {!!label && <Typography variant="subtitle2">{label}</Typography>}
        {!!label && !!required && <Typography variant="subtitle3">(*)</Typography>}
        {!!tooltip && <RenderTooltip title={tooltip} />}
      </Box>
      <FormControl error={!!error}>
        <Autocomplete
          size="small"
          multiple
          disabled={disabled}
          placeholder={placeholder}
          value={value || []}
          onChange={(_, values, reason, details) => {
            if (reason === 'createOption' && details?.option) {
              // Support both comma-separated and newline-separated values
              const newOptions = details.option
                .replaceAll('\r', '')
                .split(/[,\n]/) // Split by comma or newline
                .map((v) => v.trim())
                .filter((v) => !!v)
              onChange([...new Set([...(value || []), ...newOptions])])
            } else {
              onChange(values)
            }
          }}
          options={options}
          renderInput={(params) => <TextField variant="outlined" {...params} placeholder={placeholder} />}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip key={option} variant="outlined" color="primary" label={option} {...getTagProps({ index })} />
            ))
          }
          freeSolo
          disablePortal
          onPaste={(event) => {
            const paste = event.clipboardData.getData('text')
            // Support both comma-separated and newline-separated values when pasting
            if (paste.includes('\n') || paste.includes(',')) {
              event.preventDefault()
              const newOptions = paste
                .replaceAll('\r', '')
                .split(/[,\n]/) // Split by comma or newline
                .map((v) => v.trim())
                .filter((v) => !!v)
              onChange([...new Set([...(value || []), ...newOptions])])
            }
          }}
        />
        {error && <FormHelperText>{error.message}</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default TagsInput
